import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { FaWhatsapp } from "react-icons/fa";
import logo from '../images/logo.png'; // Make sure this path is correct
import webDevImg from '../images/homepage.gif'; // adjust relative path as needed

export default function Homepage() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isThankYouOpen, setIsThankYouOpen] = useState(false);

  // Form field state for Modal
  const [modalName, setModalName] = useState("");
  const [modalEmail, setModalEmail] = useState("");
  const [modalPhone, setModalPhone] = useState("");
  const [modalAssignmentType, setModalAssignmentType] = useState("");
  const [modalMessage, setModalMessage] = useState("");
  const [modalAccepted, setModalAccepted] = useState(false);

  // Open modal automatically on page load
  useEffect(() => {
    const timer = setTimeout(() => {
      setIsModalOpen(true);
    }, 2000); // Opens after 2 seconds (adjust as needed)
    return () => clearTimeout(timer);
  }, []);

  const closeModal = () => setIsModalOpen(false);

  const showThankYouPopup = async (e) => {
    e.preventDefault();

    // Send to Formspree
    try {
      await fetch("https://formspree.io/f/xyzdvklw", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          name: modalName,
          email: modalEmail,
          phone: modalPhone,
          assignmentType: modalAssignmentType,
          message: modalMessage,
          acceptTerms: modalAccepted ? "accepted" : "not accepted",
        }),
      });
      setIsModalOpen(false);
      setIsThankYouOpen(true);
      setTimeout(() => setIsThankYouOpen(false), 3000); // Auto-close after 3s
      // Optionally clear form fields here if desired
    } catch (error) {
      alert("There was an error submitting your form. Please try again.");
    }
  };

  return (
    <div className="bg-[#02042b] px-6 py-10 md:px-12 py-36 font-product">
      <div className="w-full max-w-[1080px] mx-auto flex flex-col lg:flex-row items-center justify-between gap-8">
        {/* Left Content */}
        <div className="lg:w-1/2 space-y-5 ml-0 lg:ml-[-10%]">
          <h1 className="text-[30px] md:text-[40px] font-semibold text-white leading-tight">
            6000+ Assignments Handled, {" "}
            <br />
            <span className="bg-gradient-to-r from-blue-400 via-blue-500 to-blue-600 text-transparent bg-clip-text font-extrabold">
              Stress-Free & On Time  <br />
            </span>{" "}
            Get Expert Assignment Help Before the Deadline!
          </h1>
          <div className="w-20 h-1 bg-blue-600"></div>
          <p className="text-[18px] md:text-[20px] leading-8 text-white opacity-80 font-product">
            Trusted by hundreds of students worldwide for original, on-time, and grade-boosting assignment help that’s easy on the pocket.
          </p>
          <button
            onClick={() => {
              setIsModalOpen(true);
              window.open("https://wa.me/917980085981", "_blank");
            }}
            className="bg-gradient-to-r from-blue-500 to-blue-600 active:scale-90 text-white py-3 px-4 rounded-md text-lg font-bold hover:from-blue-600 hover:to-blue-700 transition-all duration-200"
          >
            Get Quote
          </button>
        </div>

        {/* Right Image */}
        <div className="lg:w-1/2 flex justify-center lg:justify-end lg:mr-[-5%] mt-[-80px] lg:mt-0">
          <img
            src={webDevImg}
            alt="Web development illustration"
            loading="lazy"
            className="w-full max-w-[550px] md:max-w-[680px] h-[510px] object-contain"
          />
        </div>
      </div>

      {/* WhatsApp Floating Button */}
      <a
        href="https://wa.me/917980085981"
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-6 right-6 bg-green-500 hover:bg-green-600 text-white p-4 rounded-full shadow-lg flex items-center justify-center text-3xl duration-300 z-50"
      >
        <FaWhatsapp />
      </a>

      {isModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 backdrop-blur-sm flex justify-center items-center z-50">
          <div className="bg-white/10 backdrop-blur-xl border border-white/20 p-4 sm:p-6 rounded-2xl shadow-2xl max-w-[90%] sm:max-w-md w-full relative text-white">
            <button
              onClick={closeModal}
              className="absolute top-2 right-3 text-white hover:text-gray-300 text-xl font-bold"
            >
              ×
            </button>

            <div className="text-center space-y-2">
              <img src={logo} alt="Logo" className="w-24 h-auto mx-auto mb-2" />
              <h1 className="text-xl font-bold">Need Help With Your Assignments?</h1>
              <p className="text-sm opacity-90">Fill Out The Form Now</p>
            </div>

            <form onSubmit={showThankYouPopup} className="mt-5 space-y-3">
              <input
                type="text"
                className="w-full bg-white/80 border border-gray-300 p-2.5 rounded-lg text-black placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-400"
                placeholder="Full Name"
                required
                value={modalName}
                onChange={e => setModalName(e.target.value)}
              />

              <input
                type="email"
                className="w-full bg-white/80 border border-gray-300 p-2.5 rounded-lg text-black placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-400"
                placeholder="Email"
                required
                value={modalEmail}
                onChange={e => setModalEmail(e.target.value)}
              />

              <div className="w-full">
                <PhoneInput
                  country={"us"}
                  enableSearch={true}
                  value={modalPhone}
                  onChange={setModalPhone}
                  inputStyle={{
                    width: "100%",
                    paddingLeft: "55px", // adds space between flag & number input
                    backgroundColor: "rgba(255, 255, 255, 0.8)",
                    border: "1px solid #d1d5db",
                    borderRadius: "0.5rem",
                    paddingTop: "10px",
                    paddingBottom: "10px",
                    color: "#000",
                  }}
                  containerStyle={{ width: "100%" }}
                  buttonStyle={{ backgroundColor: "rgba(255, 255, 255, 0.8)" }}
                  dropdownStyle={{ color: "#000" }}
                  inputClass="placeholder-gray-500"
                  inputProps={{
                    name: "phone",
                    required: true,
                    placeholder: "Phone Number",
                  }}
                />
              </div>

              <select
                className="w-full bg-white/80 border border-gray-300 p-2.5 rounded-lg text-black focus:outline-none focus:ring-2 focus:ring-blue-400"
                required
                value={modalAssignmentType}
                onChange={e => setModalAssignmentType(e.target.value)}
              >
                <option value="">Select Assignment Type</option>
                <option value="essay">Essay/Dissertation</option>
                <option value="report">Report</option>
                <option value="case-study">Case Study</option>
                <option value="research-paper">Research Paper/Thesis Writing</option>
                <option value="assignment">Assignment Writing</option>
              </select>

              <textarea
                className="w-full bg-white/80 border border-gray-300 p-2.5 rounded-lg text-black placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-400"
                placeholder="Let us know your query"
                rows="3"
                value={modalMessage}
                onChange={e => setModalMessage(e.target.value)}
              ></textarea>

              <div className="flex items-start gap-2 text-sm">
                <input
                  id="acceptTerms"
                  type="checkbox"
                  required
                  checked={modalAccepted}
                  onChange={() => setModalAccepted(!modalAccepted)}
                />
                <label htmlFor="acceptTerms" className="flex flex-wrap items-center gap-1">
                  <span>I accept the</span>
                  <Link
                    to="/termsandconditions"
                    className="text-yellow-300 underline hover:text-yellow-400 transition-colors"
                  >
                    Terms and Conditions
                  </Link>
                  <span>and agree to receive updates.</span>
                </label>
              </div>

              <button
                type="submit"
                className="bg-gradient-to-r from-yellow-300 to-yellow-500 text-black font-semibold py-2.5 w-full rounded-xl shadow-lg hover:from-yellow-400 hover:to-yellow-600 transition-all duration-200"
              >
                Register Now
              </button>
            </form>
          </div>
        </div>
      )}

      {isThankYouOpen && (
        <div className="fixed inset-0 flex justify-center items-center z-50">
          <div className="bg-white/20 backdrop-blur-lg px-6 py-8 rounded-2xl shadow-xl text-black font-bold text-xl">
            Thank you for registering! We will get in touch soon.
          </div>
        </div>
      )}
    </div>
  );
}
